<template>
  <div class="issueadd" v-dragDiv v-show="selectShow">
    <div class="addTitle moveDragDiv">
      <span>选择集</span>
      <i class="el-icon-close" @click="closeArea"></i>
    </div>
    <div class="nav">
      <el-input placeholder="请输入输入构件名称" v-model="filterText" size="small" clearable> </el-input>
      <el-tree ref="tree" :expand-on-click-node="false" class="navTree" :data="datatree" :props="defaultProps" @node-click="nodeClick"
      :filter-node-method="filterNode" :default-expand-all="true" highlight-current node-key="folderId" show-checkbox 
       @check="currentOrgChangeHandler">
        <template #default="{ data }">
          <div class="treeContent">
            <span class="name" :title="data.folderName">{{data.folderName}}</span>
            <!-- <el-dropdown trigger="click"  @command="handleCommand">
              <span class="el-dropdown-link"> <i class="el-icon-more"  v-if="data.parentId==0"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="beforeHandleCommand('addFile',data)" > 新增 </el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand('del',data)" > 删除 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown> -->
            <i class="el-icon-circle-plus" @click="addFile(data)" v-if="data.parentId==0"></i>
            <i class="el-icon-delete-solid" @click="deleFile" v-if="data.parentId==0"></i>
            <el-dropdown trigger="click"  @command="handleCommand">
              <span class="el-dropdown-link"> <i class="el-icon-more"  v-if="data.parentId!=0&&data.folderType==0"></i></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="beforeHandleCommand('edit',data)" > 编辑 </el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand('del',data)" > 删除 </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </template>
      </el-tree>
    </div>
  </div>
</template>

<script>
import quaService from "@/xgzdService/quaMange-service"
export default {
  name:'selectSet',
  props:{
    objData: {
      type: Object,
      required: false
    }, 
  },
  data () {
    return {
      filterText:'',
      selectShow:false,
      datatree:[],
      defaultProps:{
        children: "childList",
        label: "label",
      },
      selectData:{},
      selectNode:{},
      isClick:false,
      deleteData:[]
    }
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  
  methods : {
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    openArea(){
      this.datatree = []
      this.getTree()
      this.selectShow = true;
    },

    closeArea(){
      this.selectShow = false
    },
    nodeClick (data,node) {
      this.isClick=true;//避免高亮构件触发构件点击事件
      this.selectData=data;
      this.selectNode=node;
      
    },
    async getTree(){
      const fileIds=this.$route.query.fileIds||this.objData.fileIds
      const params=fileIds.split(",")
      const {data} =await quaService.getSelectSetFolderTree(params);
      this.datatree=data.map(ele=>{
        ele.disabled = true;
        return ele
      });
      this.selectData={};
      this.selectNode={};
      this.isClick=false;
      
    },
    addFile(val){
      const fileIds=this.$route.query.fileIds||this.objData.fileIds
      const fileNames=this.$route.query.fileNames||this.objData.fileNames
      const fileIdList=fileIds.split(",")
      const fileNamesList=fileNames.split(",")
      const array = fileIdList.map((folderId, a) => ({folderId, folderName: fileNamesList[a]}))
      const modelList=array.map((ele)=>{
        ele.folderType=1
        return ele
      })
      this.$prompt(`请输入选择集名称`, `添加选择集名称`, {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPlaceholder: `请输入选择集名称`,
        inputErrorMessage: `请输入除空格外的15文字以内的选择集名称`,
        inputPattern: /^\S{1,15}$/,
        closeOnClickModal: false,
        closeOnPressEscape: false,
        beforeClose: async (action, { inputValue }, done) => {
          if (action === 'confirm') {
            const form = {
              folderName: inputValue,
              // folderId:"",
              folderType:0,
              parentId:val.folderId,
              modelList
            };
            try {
              await quaService.addSelectSetFolderTree(form);
              this.$message({ type: 'success', message:` 选择集添加成功 `});
              this.getTree();
              done();
            } catch (e) {
              this.$message({ type: 'error', message: `选择集添加失败` });
            }
          } else {
            done();
          }
        },
      });
    },
    
    beforeHandleCommand(flag, command) { // flag为传递的参数
      return {
        'flag': flag,
        'command': command
      }
    },
    handleCommand(val){
      switch (val.flag) {
        case "addFile":
          this.addFile(val.command)
          break;
        case "edit":
          this.editPlanHandler(val.command)
          break;
        case "del":
          const params=val.command.folderId.split(",")
          this.$confirm(`确定删除${val.command.folderName}?`, '警告', { type: 'warning', })
          .then(() => quaService.delSelectSetFolderTree(params))
          .then(() => { this.$message({ type: 'success', message: `删除${val.command.folderName}成功` }) })
          .then(() => { this.getTree() });
          break;
        default:
          break;
      }
    },
    editPlanHandler(val){
      this.$prompt(`请输入名称`, `编辑名称`, {
        inputPlaceholder: `编辑名称`,
        inputValue: val.folderName,
        inputErrorMessage: `请输入除空格外的15文字以内的名称`,
        inputPattern: /^\S{1,15}$/,
        beforeClose: async (action, { inputValue }, done) => {
          if (action === 'cancel') done();
          else {
            try {
              const params={
                folderName:inputValue,
                folderId:val.folderId
              }
              await quaService.updateSelectSetFolderTree(params);
              await this.$message({ type: 'success', message: `编辑成功` });
              await  this.getTree();
              done();
            } catch (e) {
              this.$message({ type: 'error', message: `编辑失败` });
            }
          }
        },
      });
    },
    async currentOrgChangeHandler(val, currentChecked) {
      this.selectData={};
      this.selectNode={};
      this.isClick=false;
      const data=currentChecked.checkedNodes;
      //高亮模型下的构件，先取出构件
      const array=data.filter((ele)=>ele.folderType==="1"&&!ele.modelId);
      // 整理对应数据
      const elementList=array.map((item)=>{
        return{
          elementId:item.folderId?.slice(16),
          folderId:item.parentId?.substring(item.parentId.length-16)
        }
      })
      //获取当前打开模型的数据
      const options = Monge.Model.getModels();
       //通过关联的文件id，设置对应的模型id
      for(let i=0;i<elementList.length;i++){
        options.forEach(ele => {
          if(ele.url.bimexId === elementList[i].folderId){
            elementList[i].modelId=ele.id;
          }
        });
      };
       //组成模型对应数据
      const elementArray=elementList.map((ele)=>{
        return{
          elementId:ele.elementId,
          modelId:ele.modelId
        }
      });
      Monge.Model.Selector.selectSingles(elementArray)

      //处理要删除的数据
      this.delTreeData(currentChecked.checkedNodes);
    },
    async deleFile(){
      let delData=[];
      if(this.deleteData&&this.deleteData.length>0){
        if(this.deleteData[0]?.parentId=="0"){
          delData=this.deleteData[0].childList
        }else{
          delData=this.deleteData
        }
        const params = delData.map((item) => { return item.folderId });
        await this.$confirm(`您确定要删除当前数据嘛`, '警告', {
          type: 'warning',
        });
        await quaService.delSelectSetFolderTree(params)
        await this.$message.success("删除成功");
        await this.getTree()
      }else{
        this.$message.warning("请选择要删除的数据")
      }
      
    },
    delTreeData(data){
      const list = data.filter((item) => { return item.modelId });
      //先过滤掉模型下的构件
      for(let i=0;i<data.length;i++){
        list.forEach(ele => {
          if(ele.folderId === data[i].parentId){
            data.splice(i,1)
          }
        });
      };
      this.del(data)
    },
    del(list){
      const array = list.filter((item) => { return item.folderType==="0" });
      for(let i=0;i<list.length;i++){
        array.forEach(ele => {
          if(ele.folderId === list[i].parentId){
            list.splice(i,1)
          }
        });
      };
      this.deleteData=list;
    }
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
.issueadd {
  position: absolute;
  top: 65px;
  left: 151px;
  width: 300px;
  height: calc(100% - 190px);
  max-height: 770px;
  z-index: 5;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.98);
  box-shadow: 0px 0px 4px 1px rgba(46, 91, 255, 0.17);
  border-radius: 4px;
  .addTitle{
    cursor: move;
    width: 100%;
    height: 50px;
    padding: 0 15px;
    box-sizing: border-box;
    border-bottom: 1px solid #E8EBEF;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    user-select: none;
    span{
      font-size: 16px;
      font-weight: bold;
    }
    i{
      font-size: 16px;
      cursor: pointer;
    }
  }
  .nav{
    height calc(100% - 50px)
    padding 10px
    
    .navTree{
      width 100%
      height calc(100% - 30px)
      padding 10px 0
      overflow-y auto
      .treeContent{
        width 100%
        display flex
        align-items center
      }
      .name{
        width 90%
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
      }
      .el-icon-circle-plus,.el-icon-more,.el-icon-delete-solid{
        float right
        color #909EB4
        margin-left 6px
      }
      .el-icon-more{
        transform rotate(90deg)
      }
      /deep/.el-checkbox__input.is-disabled .el-checkbox__inner{
        display none
      }
      /deep/.el-dropdown-link{
        float right
      }
    }
  }
}
</style>
